import * as React from 'react';
import { useFeatureToggles } from '../../../feature-toggles';
import { IRowAction } from '../components/query/row-action';
import { rowActionUrls } from './row-action-urls';

const rowActionToggles: Record<string, string> = {
  counselinginquiries: 'EnableOpenCounselingInquiry',
};

export const RowActionContext = React.createContext([] as IRowAction[]);

type Props = {
  children: React.ReactNode;
};
export function RowActionProvider({ children }: Props) {
  const { isFeatureEnabled } = useFeatureToggles();
  const enabledRowActions = React.useMemo(
    () =>
      rowActionUrls.filter(rowAction => {
        const toggle = rowActionToggles[rowAction.resultType.toLowerCase()];
        return toggle === undefined || isFeatureEnabled(toggle);
      }),
    [isFeatureEnabled]
  );
  return <RowActionContext.Provider value={enabledRowActions}> {children} </RowActionContext.Provider>;
}

export const useRowActions = (): IRowAction[] => React.useContext(RowActionContext);
